import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PermissionForm } from "../PermissionForm";
import "./PermissionItem.scss";

const permissionController = new Permission();

export function PermissionItem(props) {
  const { permission, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdatePermission = () => {
    setTitleModal(`Actualizar permiso: ${permission.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar el permiso ${permission.name}?`);
    onOpenCloseConfirm();
  };

  /**
   * Deletes a permission and handles the UI updates.
   *
   * This function is an asynchronous operation that attempts to delete a permission using the
   * `permissionController.deletePermission` method with the provided `accessToken` and `permission.id`.
   * If the deletion is successful, it triggers the `onReload` function to refresh the data and
   * `onOpenCloseConfirm` function to handle any UI changes related to the confirmation dialog.
   * If there is an error during the deletion process, it logs the error to the console.
   *
   * @async
   * @function onDelete
   * @returns {Promise<void>}
   */
  const onDelete = async () => {
    try {
      await permissionController.deletePermission(permission.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="permission-item">
        <div className="permission-item__info">
          <span className="permission-item__info-name">{permission.name}</span>
          <span className="permission-item__info-section">
            <b>Sección:</b> {permission.section}
          </span>
          <span className="permission-item__info-description">
            <b>Descripción:</b> {permission.description}
          </span>
        </div>
        <div className="permission-item__actions">
          <Popup
            content="Actualizar permiso"
            trigger={
              <Button icon primary onClick={openUpdatePermission}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar permiso"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <PermissionForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          permission={permission}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
